import { Axios } from 'utils'
import { EquinomBin } from 'types/models'
import { ListResponseType } from './types'

export const useBinsService = () => {
  const getBins = async () => {
    try {
      const response = await Axios.get<ListResponseType<EquinomBin>>('/bins')
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getBinById = async ({ binId }) => {
    try {
      const response = await Axios.get<ListResponseType<EquinomBin>>(
        `bins/${binId}`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getBins,
    getBinById,
  }
}
